<template>
  <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" size="default">
    <el-form-item label="职业" prop="userType">
      <el-select filterable v-model="ruleForm.userType" placeholder="">
        <el-option v-for="item in allType" :key="item.id" :label="item.roleName" :value="item.id" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-upload ref="upload" accept=".xls,.xlsx" :data="{
        userType: ruleForm.userType,
      }" :file-list="fileList" :show-file-list="false" :headers="headers" :on-success="uploadSuccess"
        :on-error="uploadError" :before-upload="beforeUploadFile" :action="userImport()" v-loading="uploading">
        <el-button type="primary">导入</el-button>
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { reactive, ref, defineEmits, defineExpose, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { userImport, skillAddOrUpdate, roleAll } from "@/http/http";
const emit = defineEmits(["dialogClose"]);
const ruleFormRef = ref();
let allType = ref("");
const ruleForm = reactive({
  userType: null,
});

const rules = reactive({
  userType: [
    {
      required: true,
      message: "请选择职业",
      trigger: "change",
    },
  ]
});

let importType = ref(1);
let fileList = ref([]);
let headers = ref({
  token: $cookies.get("token"),
});
let uploading = ref(false);
const beforeUploadFile = (file) => {
  uploading.value = true;
  const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
  if (extension != "xls" && extension != "xlsx") {
    ElMessage({
      message: "只能导入excel文件",
      type: "error",
    });
    uploading.value = false;
  }
  return extension == "xls" || extension == "xlsx";
};
const uploadSuccess = (response, file, fileList) => {
  uploading.value = false;
  if (response.code == 200) {
    ElMessage({
      message: "导入成功",
      type: "success",
    });
    emit("dialogClose", true);
  } else {
    ElMessage({
      message: "导入失败,请尝试重新导入或联系管理员",
      type: "error",
    });
  }
};
const upload = ref();
const uploadError = () => {
  uploading.value = false;
  upload.value.clearFiles();
  ElMessage({
    message: "导入失败,请尝试重新导入或联系管理员",
    type: "error",
  });
};


const _roleAll = () => {
  roleAll().then((res) => {
    if (res.data.code == 200) {
      console.log(res.data);
      allType.value = res.data.data
    }
  });
};

onMounted(() => {
  _roleAll();
});
</script>
<style scoped lang="scss">
.add-item {
  margin: -10px 0 20px 100px;
}
</style>
